import { render } from "./InfoButton.vue?vue&type=template&id=607ec07a"
import script from "./InfoButton.vue?vue&type=script&lang=js"
export * from "./InfoButton.vue?vue&type=script&lang=js"

import "./InfoButton.vue?vue&type=style&index=0&id=607ec07a&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend_tr\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__